import { BarcodeDetector } from 'barcode-detector';
import { useEffect, useState } from 'react';
import RequestState from '../../types/RequestState';
import ViewBreakpoint, {
  ViewBreakpointMinWidth,
} from '../../types/ViewBreakpoint';

const BACK_FACING_CAMERA = 'environment';

export const ERROR_STATES = {
  NONE: RequestState.NONE,
  GENERAL_ERROR: RequestState.ERROR,
  PERMISSION_DENIED_ERROR: 'NotAllowedError',
  DEVICE_ERROR: 'NotReadableError',
};

// Include all supported barcodes for maximum coverage.
const barcodeDetector = new BarcodeDetector({
  formats: [
    'aztec',
    'codabar',
    'code_128',
    'code_39',
    'code_93',
    'data_matrix',
    'databar',
    'databar_expanded',
    'dx_film_edge',
    'ean_13',
    'ean_8',
    'itf',
    'linear_codes',
    'matrix_codes',
    'maxi_code',
    'micro_qr_code',
    'pdf417',
    'qr_code',
    'rm_qr_code',
    'unknown',
    'upc_a',
    'upc_e',
  ],
});

const useBarcodeDetector = (callback) => {
  let scanIntervalID = null;

  const [initState, setInitState] = useState(ERROR_STATES.NONE);

  useEffect(() => {
    return () => {
      clearInterval(scanIntervalID);
    };
  }, []);

  navigator.mediaDevices
    .getUserMedia({
      audio: false,
      video: {
        facingMode: BACK_FACING_CAMERA,
        width: {
          min: 320,
          ideal: ViewBreakpointMinWidth[ViewBreakpoint.SM],
        },
      },
    })
    .then((localMediaStream) => {
      const video = document.getElementById('barcode_reader_renderer');
      video.srcObject = localMediaStream;
      scanIntervalID = setInterval(() => {
        barcodeDetector
          .detect(video)
          .then((barcodes) => {
            callback(barcodes[0]);
          })
          .catch((_) => {
            setInitState(RequestState.ERROR);
          });
      }, 1000);
    })
    .catch((error) => {
      switch (error.name) {
        case ERROR_STATES.PERMISSION_DENIED_ERROR:
          setInitState(ERROR_STATES.PERMISSION_DENIED_ERROR);
          break;
        case ERROR_STATES.DEVICE_ERROR:
          setInitState(ERROR_STATES.DEVICE_ERROR);
          break;
        default:
          setInitState(ERROR_STATES.GENERAL_ERROR);
          break;
      }
    });

  return [initState];
};

export default useBarcodeDetector;
